import {
  ElementsSvg,
  FolderSvg,
  ImageSvg,
  LanguageIcon,
  TemplateSvg,
  TextSvg,
  VariableSvg,
  MasterElementsSvg,
  RefElementsSvg,
  channelIcon,
} from '../../components/SidebarMenuIcons';
import { DESIGN_AREA_SIDEBAR_MENUS } from './translationValues';

export const ShortMessageTabs = [0, 5, 21, 9];

export const TabDetailsMeta = t => {
  return [
    {
      id: 0,
      label: t(DESIGN_AREA_SIDEBAR_MENUS.TEMPLATES_TAB_TOOLTIP.key, DESIGN_AREA_SIDEBAR_MENUS.TEMPLATES_TAB_TOOLTIP.value),
      icon: TemplateSvg,
      className: undefined,
    },
    {
      id: 1,
      label: t(DESIGN_AREA_SIDEBAR_MENUS.ELEMENTS_TAB_TOOLTIP.key, DESIGN_AREA_SIDEBAR_MENUS.ELEMENTS_TAB_TOOLTIP.value),
      icon: ElementsSvg,
      className: undefined,
    },
    {
      id: 13,
      label: t(DESIGN_AREA_SIDEBAR_MENUS.TEMPLATES_TAB_TOOLTIP.key, DESIGN_AREA_SIDEBAR_MENUS.TEMPLATES_TAB_TOOLTIP.value),
      icon: TemplateSvg,
      className: undefined,
    },
    {
      id: 12,
      label: t(DESIGN_AREA_SIDEBAR_MENUS.ELEMENTS_TAB_TOOLTIP.key, DESIGN_AREA_SIDEBAR_MENUS.ELEMENTS_TAB_TOOLTIP.value),
      icon: ElementsSvg,
      className: undefined,
    },
    {
      id: 2,
      label: t(DESIGN_AREA_SIDEBAR_MENUS.TEXT_TAB_TOOLTIP.key, DESIGN_AREA_SIDEBAR_MENUS.TEXT_TAB_TOOLTIP.value),
      icon: TextSvg,
      className: undefined,
    },
    {
      id: 20,
      label: t(DESIGN_AREA_SIDEBAR_MENUS.MASTER_ELEMENTS_TAB_TOOLTIP.key, DESIGN_AREA_SIDEBAR_MENUS.MASTER_ELEMENTS_TAB_TOOLTIP.value),
      icon: MasterElementsSvg,
      className: undefined,
    },
    {
      id: 6,
      label: t(DESIGN_AREA_SIDEBAR_MENUS.ELEMENTS_TAB_TOOLTIP.key, DESIGN_AREA_SIDEBAR_MENUS.ELEMENTS_TAB_TOOLTIP.value),
      type: 'layout',
      className: undefined,
    },
    {
      id: 7,
      label: t(DESIGN_AREA_SIDEBAR_MENUS.EMAIL_SETTINGS_TAB_TOOLTIP.key, DESIGN_AREA_SIDEBAR_MENUS.EMAIL_SETTINGS_TAB_TOOLTIP.value),
      type: 'link',
      className: 'settings-icon',
    },
    {
      id: 3,
      label: t(DESIGN_AREA_SIDEBAR_MENUS.UPLOADS_TAB_TOOLTIP.key, DESIGN_AREA_SIDEBAR_MENUS.UPLOADS_TAB_TOOLTIP.value),
      icon: ImageSvg,
      className: undefined,
    },
    {
      id: 18,
      label: t(DESIGN_AREA_SIDEBAR_MENUS.SETTINGS_TAB_TOOLTIP.key, DESIGN_AREA_SIDEBAR_MENUS.SETTINGS_TAB_TOOLTIP.value),
      type: 'setting',
      className: 'settings-icon',
    },
    {
      id: 4,
      label: t(DESIGN_AREA_SIDEBAR_MENUS.FOLDERS_TAB_TOOLTIP.key, DESIGN_AREA_SIDEBAR_MENUS.FOLDERS_TAB_TOOLTIP.value),
      icon: FolderSvg,
      className: undefined,
      enable: userType => {
        return userType !== 'master';
      },
    },
    {
      id: 5,
      label: t(DESIGN_AREA_SIDEBAR_MENUS.SETTINGS_TAB_TOOLTIP.key, DESIGN_AREA_SIDEBAR_MENUS.SETTINGS_TAB_TOOLTIP.value),
      type: 'setting',
      className: 'settings-icon',
    },
    {
      id: 15,
      label: t(DESIGN_AREA_SIDEBAR_MENUS.FOLDERS_TAB_TOOLTIP.key, DESIGN_AREA_SIDEBAR_MENUS.FOLDERS_TAB_TOOLTIP.value),
      icon: FolderSvg,
      className: undefined,
      enable: userType => {
        return userType !== 'master';
      },
    },
    {
      id: 8,
      label: t(DESIGN_AREA_SIDEBAR_MENUS.TRANSLATE_TAB_TOOLTIP.key, DESIGN_AREA_SIDEBAR_MENUS.TRANSLATE_TAB_TOOLTIP.value),
      icon: LanguageIcon,
      className: 'settings-icon',
    },
    {
      id: 9,
      label: t(DESIGN_AREA_SIDEBAR_MENUS.SHOW_VARIABLES_TAB_TOOLTIP.key, DESIGN_AREA_SIDEBAR_MENUS.SHOW_VARIABLES_TAB_TOOLTIP.value),
      icon: VariableSvg,
      className: 'variables',
    },
    {
      id: 11,
      label: t(DESIGN_AREA_SIDEBAR_MENUS.REFERENCED_ELEMENTS_TOOLTIP.key, DESIGN_AREA_SIDEBAR_MENUS.REFERENCED_ELEMENTS_TOOLTIP.value),
      icon: RefElementsSvg,
      className: undefined,
    },
    {
      id: 14,
      label: t(DESIGN_AREA_SIDEBAR_MENUS.REFERENCED_ELEMENTS_TOOLTIP.key, DESIGN_AREA_SIDEBAR_MENUS.REFERENCED_ELEMENTS_TOOLTIP.value),
      icon: RefElementsSvg,
      className: undefined,
    },
    {
      id: 16,
      label: t(DESIGN_AREA_SIDEBAR_MENUS.TRANSLATE_TAB_TOOLTIP.key, DESIGN_AREA_SIDEBAR_MENUS.TRANSLATE_TAB_TOOLTIP.value),
      icon: LanguageIcon,
      className: undefined,
    },
    {
      id: 17,
      label: t(DESIGN_AREA_SIDEBAR_MENUS.TRANSLATE_TAB_TOOLTIP.key, DESIGN_AREA_SIDEBAR_MENUS.TRANSLATE_TAB_TOOLTIP.value),
      icon: LanguageIcon,
      className: undefined,
    },
    {
      id: 19,
      label: t(DESIGN_AREA_SIDEBAR_MENUS.TRANSLATE_TAB_TOOLTIP.key, DESIGN_AREA_SIDEBAR_MENUS.TRANSLATE_TAB_TOOLTIP.value),
      icon: LanguageIcon,
      className: undefined,
    },
    {
      id: 10,
      label: t(DESIGN_AREA_SIDEBAR_MENUS.SHOW_VARIABLES_TAB_TOOLTIP.key, DESIGN_AREA_SIDEBAR_MENUS.SHOW_VARIABLES_TAB_TOOLTIP.value),
      icon: VariableSvg,
      className: 'variables',
    },
    {
      id: 21,
      label: t(DESIGN_AREA_SIDEBAR_MENUS.CHANNEL_TOOLTIP.key, DESIGN_AREA_SIDEBAR_MENUS.CHANNEL_TOOLTIP.value),
      icon: channelIcon,
      className: 'channel-icon',
    }
  ]};
